module.exports = "<div\n  *ngIf=\"cookieInfoVisibility\"\n  class=\"cookie-info-container\"\n>\n  <span>\n    {{ 'cookie_info.description' | translate }}\n  </span>\n  <button\n    (click)=\"hideCookieInfo()\"\n    class=\"float-right\"\n    label=\"{{ 'cookie_info.understanding' | translate }}\"\n    pButton\n    type=\"button\"\n  >\n  </button>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /dist/src/app/ui/cookie-info/cookie-info.component.html
// module id = ../../../../../src/app/ui/cookie-info/cookie-info.component.html
// module chunks = main